import { ApolloProvider } from "@apollo/client";
import { ReactNode, useEffect, useMemo, useState } from "react";
import { AuthStatus, useAuth } from "../AuthProvider";
import { apolloClientManager } from "./ApolloClientManager";
import { InactivityProvider } from "./InactivityProvider";

type Props = {
  children: ReactNode;
};

export const ApolloClientProvider = ({ children }: Props) => {
  const { authState, setAuthState } = useAuth();
  const [isInactivityDialogOpen, setIsInactivityDialogOpen] = useState(false);

  const client = useMemo(() => {
    return apolloClientManager.initialize({
      onSessionExpired: () => {
        setAuthState({
          accessToken: null,
          refreshToken: null,
          status: AuthStatus.Unauthenticated,
        });
        setIsInactivityDialogOpen(true);
      },
      onTokenRefresh: (tokens) => {
        setAuthState({
          ...tokens,
          status: AuthStatus.Authenticated,
        });
      },
      onLogout: () => {
        setAuthState({
          accessToken: null,
          refreshToken: null,
          status: AuthStatus.Unauthenticated,
        });
      },
    });
  }, [setAuthState]);

  useEffect(() => {
    apolloClientManager.updateAuth(authState);
  }, [authState]);

  return (
    <ApolloProvider client={client}>
      <InactivityProvider
        isVisible={isInactivityDialogOpen}
        setIsVisible={setIsInactivityDialogOpen}
      >
        {children}
      </InactivityProvider>
    </ApolloProvider>
  );
};
